<template>
	<div>
		<div v-if="isPc == true" class="breadcrumb greyfont warp">
			<ul>
				<li><router-link to="/center">个人中心</router-link></li>
				<li>
					<span>-</span>
					<p>个人信息</p>
				</li>
			</ul>
		</div>
		<div :class="isPc == true ? 'routerpage warp' : ''">
			<div :class="isPc == true ? 'tabar_bg' : 'tabar_bg-mob'">
				<p>个人信息</p>
			</div>

			<HospitalGUI v-if="isPc == true"></HospitalGUI>

			<div :class="isPc == true ? 'userLogin' : 'userLogin-mob warp-mob'">
				<div class="userLogin_input">
					<div>姓名</div>
					<input type="text" placeholder="请填写姓名" v-model="full_name" />
				</div>
				<div class="userLogin_input">
					<div>身份证号</div>
					<input type="text" placeholder="请填写身份证号" v-model="idcard" />
				</div>
				<div class="userLogin_input_radio">
					<div class="userLogin_input_radio_title">性别</div>
					<div class="userLogin_input_radio_radio">
						<input type="radio" name="sex" id="male" :checked="sex == '男'" @click="changeSex('男')" />
						<input type="radio" name="sex" id="famale" :checked="sex == '女'" @click="changeSex('女')" />
						<label for="male"><p class="male" style="width: 190px">男</p></label>
						<label for="famale"><p class="famale" style="width: 190px">女</p></label>
					</div>
				</div>
				<div class="userLogin_input">
					<div>手机号</div>
					<input disabled type="text" placeholder="请填写手机号" v-model="mobile" />
				</div>
				<div class="userLogin_btn" @click="save">保存</div>
			</div>
		</div>
	</div>
</template>

<script>
import HospitalGUI from '../components/HospitalGUI.vue';
export default {
	name: 'WebLijinhospitalPersonMsg',
	components: {
		HospitalGUI
	},
	data() {
		return {
			isPc: true,
			full_name: '',
			idcard: '',
			sex: '',
			mobile: ''
		};
	},

	mounted() {
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		let old_member_json = localStorage.getItem('eden_member');
		if (typeof old_member_json == 'string') {
			let old_member = JSON.parse(old_member_json);
			if (old_member) {
				this.full_name = old_member.full_name;
				this.idcard = old_member.idcard;
				this.sex = old_member.sex;
				this.mobile = old_member.mobile;
			}
		}
	},

	methods: {
		save() {
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/save',
				params: {
					mobile: this.mobile,
					full_name: this.full_name,
					idcard: this.idcard,
					sex: this.sex
				}
			})
				.then((res) => {
					//请求成功
					console.log('save', res.data);
					if (res.data.code) {
						this.$message({
							message: '已保存',
							type: 'success'
						});
						let member = res.data.data;
						localStorage.setItem('eden_member', JSON.stringify(member));
						this.full_name = member.full_name;
						this.idcard = member.idcard;
						this.sex = member.sex;
						this.mobile = member.mobile;
					} else {
						this.$message({
							message: res.data.msg,
							type: 'error'
						});
					}
				})
				.catch((error) => {
					//请求失败
					console.log('save', error);
				});
		},
		changeSex(sex) {
			this.sex = sex;
		}
	}
};
</script>

<style lang="scss" scoped></style>
